import { Container, Typography } from '@mui/material';
import styled from '@emotion/styled';
import {Grid} from '@mui/material';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
// import Presale from "."
const PacmanContainer = styled(Container)`
    background-image:url("./assets/header-bg.png");
    background-size:contain;
    background-repeat:no-repeat;
    background-position:top;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    padding-top:40px;
    padding-bottom:40px;
    background-color:#000B29;
    @media(max-width: 950px) and (min-width: 600px){
        background-image:url("./assets/header-bg.png");
        background-size:contain;
        padding-top:80px;
    }
    // @media (max-width: 379px){
    //     background-image:url("./assets/header-bg.png");
    //     background-size:cover;
    //     padding-top:150px;
    //     padding-bottom:130px;
    //     background-position:top;
    // }
    @media (max-width:450px){
        background-image:url("./assets/pm-mobile-bg.png");
        background-size: contain;
        padding-top: 39%;
        padding-bottom:200px;
        background-position:top;
    }
    @media (max-width:600px) and (min-width:451px){
        background-image:url("./assets/pm-mobile-bg.png");
        background-size: cover;
        padding-top: 39%;
        padding-bottom:230px;
        background-position:top;
    }
    @media (min-width:1600px){
        background-size:100% 100%;
    }
    @media (max-width:1280px) and (min-width:901px){
        background-size:contain;
        background-position:top;
    }
    @media (min-width:2000px){
        padding-top:150px;
        padding-bottom:350px;
    }
`
const ContentGrid = styled(Grid)`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
`
const Subheading = styled(Typography)`
    color:#fff;
    font-family:Emulogic-zrEw;
    font-size:25px;
    font-weight:400;
    text-align:center;
    @media(max-width: 950px) and (min-width: 600px){
        font-size:14px;
    }
    @media (max-width: 650px){
        font-size:12px;
    }
`
const P = styled.p`
    color:#fff;
    font-family:poppins;
    font-size:15px;
    text-align:center;
    @media (max-width: 650px) and (min-width: 350px){
        font-size:12px;
    }
    @media(max-width: 950px) and (min-width: 600px){
        font-size:11px;
    }
    @media (max-width: 350px){
        font-size:11px;
    }
`

const HeadingWrapper = styled.div`
    margin-bottom:10px;
    @media(max-width: 950px) and (min-width: 200px){
        display:flex;
        justify-content: center;
    }
`
const HeadingImg = styled.img`
    width:100%;
    max-width:100%;
    height:auto;
    @media (max-width: 650px){
        width:90%;
        max-width:100%;
        height:auto; 
    }
    @media(max-width: 950px) and (min-width: 600px){
        width:70%;
        max-width:100%;
        height:auto; 
    }
`
const BottomImg = styled.img`
    width:350px;
    max-width:100%;
    @media (max-width: 749px){
        width:230px;
    }
    @media (min-width:2000px){
        width:550px;
    }
    @media (min-width:1200px){
        width:550px;
    }
`
const ImgGrid = styled(Grid)`
    margin-top:50px;
    @media (min-width:2000px){
        margin-top:100px;
    }
    @media (max-width: 650px){
        margin-top: 100px;
        display:none;
    }
`
const Preimg = styled.img`
padding:20px 0;
width:100%;
height: auto;

`
function Pacman() {
    useEffect(() => {
        AOS.init({duration: 1200,});
      }, [])
  return (
        <PacmanContainer maxWidth="xxl" id="pacman">
            <ContentGrid container item xs={12} sm={10} md={7}>
                <HeadingWrapper  data-aos="zoom-in">
                    <HeadingImg src="./assets/HeadingImg.png"/>
                </HeadingWrapper>
                <Subheading variant='h3'  data-aos="zoom-in">Reloaded</Subheading>
                <P  data-aos="zoom-in">Join the ultimate gaming revolution as Pacman comes to life on the blockchain!
                    Score as you go and make some serious cash along the way.
                    </P>
                  {/* <a href="" target="blank">
                     <Preimg src="./assets/presale.png"/>
                    </a>  */}
                    <Typography variant='h5' color="#fff" sx={{textAlign: 'center',wordBreak: 'break-word'}}>Contract:<br/>0xFa755bEC92888376f7969f1Cc4649c645950f81e</Typography>
            </ContentGrid>
            <ImgGrid item xs={12} sm={10} md={7}><BottomImg src="./assets/Pacman-lastimg.png"/></ImgGrid>
        </PacmanContainer>
  );
}

export default Pacman;
